import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/custom-validator';
import { Constants } from 'src/app/shared/constants';
import { AdminSettingsService } from '../../../servicies/admin-settings.service';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { ResultOfT, Result } from 'src/app/shared/models/response/result';
import { SettingsPluginRequestModel } from 'src/app/shared/models/request/settings/settings-plugin-request-model';
import { SettingsPluginResponseModel, PluginSMSModel, PluginFTPModel } from 'src/app/shared/models/response/settings/settings-plugin-response-model';
import { SettingsPluginServiceResponseModel } from 'src/app/shared/models/response/settings/settings-plugin-service-response-model';
import { SettingsRequestModel } from 'src/app/shared/models/request/settings/settings-request-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';

@Component({
    selector: 'app-ftp',
    templateUrl: './ftp.component.html',
    styleUrls: ['./ftp.component.sass'],
    standalone: false
})
export class FtpComponent extends BaseComponent implements OnInit, OnDestroy {
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  settingsPluginResponseModel: SettingsPluginResponseModel;
  settingsPluginRequestModel: SettingsPluginRequestModel;
  pluginModel: PluginFTPModel;
  loggedInUserId: number;
  isTestSMS: boolean = false;
  testNumber: string;
  //pluginServices: SettingsPluginServiceResponseModel[];
  ftpProtocol: { protocolName: string, value: number }[];

  formFields = {
    protocol: 'protocol',
    hostname: 'hostname',
    userName: 'userName',
    password: 'password',
    port: 'port',
    rootDirPath: 'rootDirPath',
  };

  validationMessages = {
    protocol: {
      required: 'Protocol is required',
      //validCharacters: 'Enter valid from email address'
    },
    hostname: {
      required: 'Host name is required',
      //validCharacters: 'Enter valid from name'
    },
    userName: {
      required: 'User name is required',
    },
    password: {
      required: 'Password is required',
      //validCharacters: 'Enter valid contact name'
    },
    port: {
      required: 'Port is required',
      //validCharacters: 'Enter valid contact name'
    },
    rootDirPath: {
      required: 'Root Directory Path is required',
      //validCharacters: 'Enter valid contact name'
    },
  };

  constructor(private router: Router,
    private webStorageService: WebStorageService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private settingsService: AdminSettingsService,
    messageService: MessageService) {
    super(messageService);
  }

  ngOnDestroy(): void {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress) {
      this.progress.complete();
    }
  }

  async ngOnInit() {
    this.buildForm();
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.getPluginServices();
    this.getPluginConfiguration();

    this.ftpProtocol = [
      { protocolName: 'SFTP', value: 0 },
      { protocolName: 'FTP', value: 1 },
    ];

  }
  private getPluginServices() {
    // this.loading = true;
    // this.settingsService.getPluginServices()
    //   .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
    //   .subscribe((result: ResultOfT<any>) => {
    //     this.processResult<any>(result, () => {
    //       this.pluginServices = result.responseModel;
    //       this.pluginServices = this.pluginServices.filter(where => where.pluginName == 'FTP')
    //     });
    //   }, (httpResponseError) => {
    //     this.showErrorMessage(httpResponseError.message);
    //   });
  }

  private getPluginConfiguration() {
    this.loading = true;
    this.settingsService.getPluginConfiguration(Constants.pluginSettingFTP)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          this.settingsPluginResponseModel = result.responseModel;
          this.setValuesToForm();
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }
    var applicationPluginRequestModel = this.getValuesFromForm();
    const manageApplicationGeneral = this.settingsService.updatePluginConfiguration(applicationPluginRequestModel);

    this.loading = true;
    manageApplicationGeneral.pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: Result) => {
        if (result && result.isSuccess) {
          this.showSuccessMessage('Plugin FTP settings is updated successfully');
        } else {
          this.showErrorMessage(result.message);
        }
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }

  private getValuesFromForm(): SettingsPluginRequestModel {
    const form = this.form;
    var settingPluginRequestModel = new SettingsPluginRequestModel();
    settingPluginRequestModel = this.settingsPluginResponseModel;
    //settingPluginRequestModel.appPluginSettingsDisplayValue = form.get(this.formFields.service).value;
    this.pluginModel.fTPProtocol = form.get(this.formFields.protocol).value;
    this.pluginModel.fTPHostName = form.get(this.formFields.hostname).value;
    this.pluginModel.fTPUserName = form.get(this.formFields.userName).value;
    this.pluginModel.fTPPassword = form.get(this.formFields.password).value;
    this.pluginModel.fTPPort = form.get(this.formFields.port).value;
    this.pluginModel.fTPRootDirPath = form.get(this.formFields.rootDirPath).value;
    settingPluginRequestModel.appPluginSettingsValue = JSON.stringify(this.pluginModel);
    settingPluginRequestModel.modifiedByUserInfoId = this.loggedInUserId;
    return settingPluginRequestModel;
  }

  private setValuesToForm() {
    this.form.reset();
    if (!this.settingsPluginResponseModel) {
      return;
    }
    this.pluginModel = JSON.parse(this.settingsPluginResponseModel.appPluginSettingsValue);
    const form = this.form;
   // form.get(this.formFields.service).setValue(this.settingsPluginResponseModel.appPluginSettingsDisplayValue);
   form.get(this.formFields.protocol).setValue(this.pluginModel.fTPProtocol); 
   form.get(this.formFields.hostname).setValue(this.pluginModel.fTPHostName);
    form.get(this.formFields.userName).setValue(this.pluginModel.fTPUserName);
    form.get(this.formFields.password).setValue(this.pluginModel.fTPPassword);
    form.get(this.formFields.port).setValue(this.pluginModel.fTPPort);
    form.get(this.formFields.rootDirPath).setValue(this.pluginModel.fTPRootDirPath);
  }

  private buildForm() {
    const formGroup = this.formBuilder.group({});
    formGroup.addControl(this.formFields.protocol, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.hostname, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.userName, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.password, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.port, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.rootDirPath, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    this.form = formGroup;
  }

  onClickTest() {
    this.isTestSMS = true;
    this.testNumber = '';
  }

  SendTestSMS() {
    if (!this.testNumber) {
      this.showWarningMessage('Please enter a number to send sms.');
      return;
    }
    this.loading = true;
    this.settingsService.sendTestSMS(this.testNumber)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => {
          if (result.responseModel) {
            this.showSuccessMessage('Test SMS sent successfully.');
          }
          else {
            this.showWarningMessage('Test SMS not sent.');
          }
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  CancelSMS() {
    this.isTestSMS = false;
    this.testNumber = '';
  }
}
